
export function isFeatureEnabled(key) {
  const raw = process.env[key];
  if (raw === undefined || raw === null) return false;

  const v = String(raw).toLowerCase().trim();
  return v === 'true' || v === '1' || v === 'yes' || v === 'on';
}